<div class="login-container" fxLayout="row" fxLayoutAlign="center">
    <div fxFlex="40" fxFlex.lt-md="100">
        <lib-login (loggedInProfile)="onLogin($event)"
                   (errorMsg)="onErrorOccurred($event)">
        </lib-login>
    </div>
</div>
